/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import { createRoute } from 'openvsx-webui';

export namespace AnalyticsRoutes {
  /** Router pattern for the whole section; the page shell hosts the sub-routes. */
  export const MAIN = createRoute(['analytics', '*']);
  export const OVERVIEW = createRoute(['analytics']);
  /** Path segment of the comparison sub-route, relative to the overview. */
  export const COMPARE_SEGMENT = 'compare';
  export const COMPARE = createRoute(['analytics', COMPARE_SEGMENT]);
}
